<div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="import-logs-modal" *ngIf="screenInnerWidth >= 1000">
<!-- <div *ngIf="screenInnerWidth >= 1000" class="modal-content logs-modal"> -->
  <div style="background-color: #548235;  height: 7px;"></div>
  <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
    <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Import Logs: &nbsp;&nbsp; {{this.importSchedule.name}}</h5>
    <!-- <button (click)="logModalRef.hide()" aria-label="Close" class="close pull-right" type="button"><span
      aria-hidden="true">&times;</span></button> -->
    <button
      (click)="bsModalRef.hide()"
      class="ms-auto fas fa-times"pe="button"
      style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
    </button>
  </div>

  <div style="margin-top: 10px; margin-bottom: 5px;">
    <input (datesUpdated)="datesUpdated('')" [(ngModel)]="selectedDateRange" [alwaysShowCalendars]="true" [isInvalidDate]="isInvalidDate"
           [linkedCalendars]="true" [ranges]="ranges" [showClearButton]="true" [showCustomRangeLabel]="true" autocomplete="off"
           ngxDaterangepickerMd placeholder="Select Date Range" type="text" style="width:220px; margin-left: 10px; font-size: medium;" />
    &nbsp;
    <button (click)="datesUpdated('Today')" class="btn" style="color: rgb(0, 123, 255);" type="button">Today</button>
    <button (click)="datesUpdated('Last 2 Days')" class="btn" style="color: rgb(0, 123, 255);" type="button">Last 2 Days</button>
    <button (click)="datesUpdated('Last 7 Days')" class="btn" style="color: rgb(0, 123, 255);" type="button">Last 7 Days</button>
  </div>

  <tabset>
    <p-table #importLogTable *ngIf="importLogs.length > 0" [columns]="importLogCols"
             [exportFunction]="exportCsv" [value]="importLogs" exportFilename={{exportName}} sortField="createdDate"
             sortOrder="-1" [scrollable]="true" scrollHeight="65vh">

      <ng-template let-columns pTemplate="header">
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field"  [ngStyle]="{'width': col.width}" style="background-color: var(--kig-section-header-bg); flex: none;">
            {{col.header}}
            <!-- <p-sortIcon *ngIf="col.header!=''" [field]="col.field"></p-sortIcon> -->
          </th>
        </tr>
      </ng-template>
      <ng-template let-columns="columns" let-rowData pTemplate="body">
        <tr>
          <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
            {{ rowData.createdDate | date : 'medium' }}
          </td>

          <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
            {{ rowData.message }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </tabset>
</div>